import messages from './exchange-rate-afir-results-lang.json';
import getPosition from '../../../common/js/get-position/get-position';
import moment from 'moment';
import { DISPLAY_DATE_FORMAT, BACKEND_DATE_FORMAT } from '../../../common/js/constants/constants';

const desktopHeaders = ['unitSize', 'middleRate', 'foreignExchangeSellingRate'];
const mobileHeaders = ['middleRate', 'foreignExchangeSellingRate'];
export default {
	data() {
		return {
			currentColumn: 0,
			stickyTop: false,
			stickyBottom: false
		};
	},
	props: {
		date: {
			required: true
		},
		results: {
			required: true
		},
		foreignType: {
			required: false
		}
	},
	i18n: { messages },
	computed: {
		headers() {
			return this.isMobile ? mobileHeaders : desktopHeaders;
		},
		isMobile() {
			return this.$resize && this.$mq.below(767);
		},
		concatTableCaption() {
			let rateType;
			let ratesA11Y = this.$t('ratesA11Y');
			rateType = this.$t('hufA11Y') + ' ' + ratesA11Y;
			return rateType + ' ' + moment(this.date, BACKEND_DATE_FORMAT).format(DISPLAY_DATE_FORMAT[this.$i18n.locale]) + ' ' + this.results.time;
		}
	},
	methods: {
		onScroll() {
			if (this.$refs.results) {
				let scrollTop = getPosition(this.$refs.results).y;
				let tableHeight = document.getElementById('rate_data').offsetHeight;
				this.stickyTop = scrollTop < 0 && scrollTop + tableHeight > 80;
			}
		}
	},
	mounted() {
		window.addEventListener('scroll', this.onScroll);
	}
};
